import { render, staticRenderFns } from "./AbstractText.vue?vue&type=template&id=40f4c9aa"
import script from "./AbstractText.vue?vue&type=script&lang=js"
export * from "./AbstractText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports